/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Color_PresetsInputs */

const cs_pipelines_color_presets = /** @type {(inputs: Pipelines_Color_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paleta`)
};

const en_pipelines_color_presets = /** @type {(inputs: Pipelines_Color_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palette`)
};

/**
* | output |
* | --- |
* | "Palette" |
*
* @param {Pipelines_Color_PresetsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_color_presets = /** @type {((inputs?: Pipelines_Color_PresetsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Color_PresetsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_color_presets(inputs)
	return cs_pipelines_color_presets(inputs)
});